import React from 'react';
import { Users, ChevronRight, ChevronDown } from 'lucide-react';
import { Badge } from '../../components/ui/badge';

const flattenTree = (referrals, level = 1, parentExpanded = true, expanded = {}) => {
  if (!referrals || !parentExpanded) return [];
  const result = [];
  for (const ref of referrals) {
    result.push({ ...ref, level });
    if (expanded[ref.id] && ref.children && ref.children.length > 0) {
      result.push(...flattenTree(ref.children, level + 1, true, expanded));
    }
  }
  return result;
};

const LEVEL_COLORS = {
  1: 'bg-green-500/20 text-green-400',
  2: 'bg-blue-500/20 text-blue-400',
  3: 'bg-purple-500/20 text-purple-400',
};

export const ReferralTreeView = ({ referrals }) => {
  const [expanded, setExpanded] = React.useState({});
  if (!referrals || referrals.length === 0) return null;

  const toggleExpand = (id) => setExpanded(prev => ({ ...prev, [id]: !prev[id] }));
  const flatList = flattenTree(referrals, 1, true, expanded);

  return (
    <div className="space-y-2">
      {flatList.map((ref, idx) => (
        <div key={ref.id || `ref-${idx}`} className="border-l-2 border-slate-700 pl-4" style={{ marginLeft: (ref.level - 1) * 16 }}>
          <div className="flex items-center justify-between p-3 rounded-lg bg-slate-900/50 hover:bg-slate-800/50 transition-colors cursor-pointer" onClick={() => toggleExpand(ref.id)}>
            <div className="flex items-center gap-3">
              <div className={`w-8 h-8 rounded-full flex items-center justify-center ${LEVEL_COLORS[ref.level] || LEVEL_COLORS[3]}`}>
                <Users size={16} />
              </div>
              <div>
                <p className="text-white font-medium">{ref.name}</p>
                <p className="text-slate-500 text-xs">{ref.email} - Nivel {ref.level}</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              {ref.has_subscription && <Badge className="bg-amber-500/20 text-amber-400 text-xs">{ref.plan?.toUpperCase()}</Badge>}
              {ref.referral_count > 0 && <span className="text-slate-400 text-sm">+{ref.referral_count} refs</span>}
              {ref.children && ref.children.length > 0 && (expanded[ref.id] ? <ChevronDown size={18} className="text-slate-400" /> : <ChevronRight size={18} className="text-slate-400" />)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
